import { useTranslation } from 'react-i18next';
import { cn } from '@/lib/cn';
import { HorizontalScrollRow } from '@/ui/common';
import { TimeFilterItem } from './TimeFilterItem';

export type MarketFilterRailItem = {
  key: string;
  label: string;
};

export interface MarketFilterRailProps {
  markets: MarketFilterRailItem[];
  selectedKey: string;
  onSelect: (key: string) => void;
  className?: string;
}

/**
 * Mobile-only horizontal chips that switch which single market every event
 * row in a list displays.
 */
export function MarketFilterRail({
  markets,
  selectedKey,
  onSelect,
  className,
}: MarketFilterRailProps) {
  const { t } = useTranslation();

  if (markets.length < 2) return null;

  return (
    <HorizontalScrollRow
      aria-label={t('Market filters', { defaultValue: 'Market filters' })}
      className={cn('h-8 items-center gap-2 pl-0', className)}
    >
      {markets.map((market) => (
        <TimeFilterItem
          key={market.key}
          label={market.label}
          selected={market.key === selectedKey}
          onClick={() => onSelect(market.key)}
        />
      ))}
    </HorizontalScrollRow>
  );
}
